import { render, staticRenderFns } from "./codeEmail.vue?vue&type=template&id=80c1f0cc"
import script from "./codeEmail.vue?vue&type=script&lang=js"
export * from "./codeEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports